export default {
  getMailAttachments(params) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/mail-attachments`, {
      params,
    });
  },
};